import React, {Component} from 'react';
import './Category.css';

export default class Category extends Component {

    onClickSearch = (date) => {
        this.props.UpdateValue(date);
    }

    render() {
        return (
            <section className="category">
                <button onClick={() => this.onClickSearch('5/math')}
                        className="category_elem">
                    <h1>Math</h1>
                    <div className="category_elem_describe">
                        <div className="title">5/math</div>
                        <div className="describe">
                            5 is the number of platonic solids.
                        </div>
                    </div>
                </button>

                <button
                        onClick={() => this.onClickSearch('42/trivia')}
                        className="category_elem">
                    <h1>Trivia</h1>
                    <div className="category_elem_describe">
                        <div className="title">42/trivia</div>
                        <div className="describe">
                            42 is the number of little squares forming the left side trail
                            of Microsoft's Windows 98 logo.
                        </div>
                    </div>
                </button>

                <button onClick={() => this.onClickSearch('7/6/date')}
                        className="category_elem">
                    <h1>Date</h1>
                    <div className="category_elem_describe">
                        <div className="title">7/6/date</div>
                        <div className="describe">
                            July 3rd is the day in 2006 that Valencia metro accident leaves
                            43 dead in Valencia, Spain.
                        </div>
                    </div>
                </button>
            </section>
        );
    }
}
